import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { v4 as uuidv4 } from "uuid";

const CloudMigrationFaq = () => {
  const webDevelopmentFAQs = [
    {
      id: uuidv4(),
      question:
        "What is cloud migration, and why is it essential for businesses?",
      answer:
        "Cloud migration involves transferring digital assets, applications, and data from on-premises environments to cloud infrastructure. It is essential for businesses seeking increased scalability, cost-efficiency, and flexibility in their operations.",
    },
    {
      id: uuidv4(),
      question:
        "How does Flint Infotech ensure a smooth and secure cloud migration process?",
      answer:
        "Flint Infotech employs a meticulous approach to cloud migration, encompassing detailed planning, risk assessment, and execution. Our experts prioritize data security, employ robust encryption protocols, and conduct thorough testing to minimize downtime and ensure a secure transition.",
    },
    {
      id: uuidv4(),
      question:
        "Can Flint Infotech assist in migrating both applications and databases to the cloud?",
      answer:
        " Absolutely. Flint Infotech specializes in comprehensive cloud migration solutions, covering applications, databases, and entire IT infrastructures. Our tailored approach ensures a seamless transition, whether you are moving specific components or your entire digital ecosystem.",
    },
    {
      id: uuidv4(),
      question:
        "How can cloud migration benefit my business in terms of cost savings?",
      answer:
        "Cloud migration offers cost savings by eliminating the need for significant upfront hardware investments. With a pay-as-you-go model, businesses only pay for the resources they use, resulting in optimized costs. Additionally, the scalability of cloud resources allows for efficient budget allocation.          ",
    },
    {
      id: uuidv4(),
      question:
        " What post-migration support and optimization services does Flint Infotech provide?",
      answer:
        "After migration, Flint Infotech continues to support businesses with ongoing management and optimization services. This includes monitoring cloud environments, implementing cost-saving measures, and adapting to evolving business needs, ensuring sustained benefits and performance in the cloud.          ",
    },
  ];
  return (
    <div className="px-5 sm:px-60 mt-10" id="faq">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold m-10 text-[#333e49]">
        Frequently Asked Questions
      </p>
      {webDevelopmentFAQs.map((item) => (
        <Accordion key={item.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className="font-notosans font-bold"
          >
            {item.question}
          </AccordionSummary>
          <AccordionDetails className="font-notosans">
            {item.answer}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default CloudMigrationFaq;
